import img from 'assets/images/new_entities_verify_icon.png'
import { CeruleanButton } from 'components/Button'
import I18n from 'components/I18n'
import messages from 'lang'
import React from 'react'
import styled from 'styled-components'
import { color } from 'utils'

import { Wrapper } from './styles'

const Content = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${color('white')};

  h1 {
    font-weight: 600;
    line-height: 150%;
    margin: 0.5rem 0;
    font-size: 1.5rem;
  }

  p {
    margin: 0;
    color: ${color('dark')};
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
`

const Footer = styled.footer`
  margin: 1rem 0;

  > button {
    width: 100%;
  }
`

const Resubmission = ({ onClose }) => (
  <Wrapper>
    <Content>
      <img src={img} />
      <h1>
        <I18n data={messages.kyc_resubmission_title} />
      </h1>
      <p>
        <I18n data={messages.kyc_resubmission_description} />
      </p>
    </Content>
    <Footer>
      <CeruleanButton onClick={onClose}>
        <I18n data={messages.kyc_resubmission_cta} />
      </CeruleanButton>
    </Footer>
  </Wrapper>
)

export default Resubmission
